import { AplicabilidadeModel } from './../../model/produto/aplicabilidade.mode';
import { Observable } from 'rxjs/Observable';
import { ResponsePageable } from './../../model/cliente/pageable/responsePageable.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment.prod';
import { Injectable } from '@angular/core';

@Injectable()
export class AplicabilidadeService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getPageAplicabilidade(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-aplicabilidades?page=${page}&size=${size}`, this.httpOptions);
  }

  getAplicabilidade(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-aplicabilidades', this.httpOptions);
  }

  getAplicabilidadePorIdPreco(id: any): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-aplicabilidades/' + id, this.httpOptions);
  }

  getAplicabilidadeDesciaoPorIdPreco(id: any): Observable<any>{
    return this.httpClient.get<any>(this.apiURL + '/view/listar-aplicabilidades-descricao/' + id, this.httpOptions);
  }

  postAplicabilidade(grupoProduto: AplicabilidadeModel): Observable<AplicabilidadeModel>{
    return this.httpClient.post<AplicabilidadeModel>(this.apiURL + '/new/adicionar-aplicabilidade', grupoProduto, this.httpOptions);
  }

  putAplicabilidade(grupoProduto: AplicabilidadeModel): Observable<AplicabilidadeModel>{
    return this.httpClient.put<AplicabilidadeModel>(this.apiURL + '/edit/editar-aplicabilidade', grupoProduto, this.httpOptions);
  }

  deleteAplicabilidade(id: any){
    return this.httpClient.delete(this.apiURL + '/delete/apagar-aplicabilidade/' + id, this.httpOptions);
  }

  getAplicabilidadeUnico(id: any): Observable<AplicabilidadeModel> {
    return this.httpClient.get<AplicabilidadeModel>(this.apiURL + '/view/listar-aplicabilidade/' + id, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/produto/aplicabilidade.service.ts